import DashboardPage from "./DashboardPage";
import PortfolioDashboard from "../../components/Dashboard/PortfolioDashboard";

export default function DashboardsPortfolio() {
  return (
    <DashboardPage
      title="Portfólio de certificações"
      subtitle="Quantas empresas, quantas certificadas e a saúde da validade"
      info="Cada card é um indicador do portfólio. O gráfico mostra quantas certificações estão em cada etapa do fluxo; a validade separa ativos, a vencer (90 dias) e vencidos."
    >
      <PortfolioDashboard />
    </DashboardPage>
  );
}
